<div class="container">
  <input [value]="value" readonly />
  <div
    class="icon"
    [class.clicked]="buttonClicked"
    inlineSVG="assets\images\copy.svg"
    [cdkCopyToClipboard]="value"
    (click)="click()"></div>
</div>
